import React from "react";
import "./index.css";
import { Button, Space } from "antd";

export default function Modal(props) {
  return (
    <div className="modal-container">
      <div className="modal">
        <h2 className="modal-title">{props.title}</h2>
        <div>{props.content}</div>
        <div className="modal-btn">
          <Space>
            <Button type="primary" htmlType="submit" onClick={props.confirm}>
              确认
            </Button>
            <Button htmlType="button" onClick={props.cancel}>
              取消
            </Button>
          </Space>
        </div>
      </div>
    </div>
  );
}
